import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/api";
import { useSite, imgUrl } from "@/context/SiteContext";
import Navbar from "@/components/site/Navbar";
import ChatWidget from "@/components/site/ChatWidget";
import { ErrorBoundary } from "@/components/ErrorBoundary";

export default function ArticlePage() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [err, setErr] = useState(false);
  const { lang, t, draft } = useSite();
  useEffect(() => { api.get(`/public/articles/${slug}`, { params: draft ? { lang, draft: true } : { lang } }).then((r) => setA(r.data)).catch(() => setErr(true)); }, [slug, lang, draft]);
  return (
    <div className="min-h-screen">
      <Navbar />
      <article className="mx-auto max-w-3xl px-4 py-16 sm:px-6" data-testid="article-page">
        <Link to="/#artikel" className="mb-8 inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#0F2B48]" data-testid="article-back-link"><ArrowLeft size={14} /> {t("article.back")}</Link>
        {err && <p>{t("article.notfound")}</p>}
        {a && (
          <>
            <p className="eyebrow">{a.category} · {a.read_time} {t("art.min")}</p>
            <h1 className="mt-4 text-4xl font-extrabold tracking-tight text-[#0F2B48] sm:text-5xl" data-testid="article-title">{a.title}</h1>
            <img src={imgUrl(a.cover)} alt={a.title} className="mt-10 h-80 w-full object-cover" />
            <div className="mt-10 space-y-5 text-base leading-relaxed text-slate-700">{a.content.split("\n").filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}</div>
          </>
        )}
      </article>
      <ErrorBoundary compact><ChatWidget /></ErrorBoundary>
    </div>
  );
}
